import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { ElementRef, FC, ReactNode, useRef } from 'react';
import { Insets, StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { HoldItem, HoldMenuPlacement, OverlayComponentProps } from './HoldMenu';
import Menu from './Menu';

export const AppHoldItem: FC<{
  children?: ReactNode;
  placement?: HoldMenuPlacement;
  component: OverlayComponentProps['component'];
  presentOnPress?: boolean;
  style?: StyleProp<ViewStyle>;
  backgroundMode?: 'blur' | 'transparent';
  disabled?: boolean;
  hitSlop?: Insets;
  onPress?: () => void;
}> = ({ style, presentOnPress, hitSlop, ...props }) => {
  const isMobile = useIsMobileLayout();
  const ref = useRef<ElementRef<typeof HoldItem>>(null);
  return (
    <TouchableOpacity
      disabled={props.disabled}
      onLongPress={() => ref.current?.present()}
      onPress={presentOnPress ? () => ref.current?.present() : props.onPress}
      style={style}
      hitSlop={hitSlop}
    >
      <HoldItem
        ref={ref}
        backgroundMode={isMobile ? 'blur' : 'transparent'}
        {...props}
      />
    </TouchableOpacity>
  );
};

export const AppMenu: typeof Menu = props => {
  const { rpx } = useResponsiveContext();
  return (
    <Menu
      css={`
        background-color: white;
        box-shadow: 1px ${rpx(5)}px ${rpx(15)}px rgba(0, 0, 0, 0.1);
      `}
      {...props}
    >
      {props.children}
    </Menu>
  );
};

AppMenu.Item = Menu.Item;
